<template>
  <div class="identity">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="title"><span>个人信息</span></div>
        <div class="dv_list">
          <ul>
            <li><p>姓名</p><span>{{ accountInfo.chineseName }}</span></li>
            <li>
              <p>身份证号</p>
              <span v-if="accountInfo.idDocumentNumber && accountInfo.idDocumentNumber !== 'TEST1693844836539' && !accountInfo.idDocumentNumber.startsWith('NOID')">
                {{ accountInfo.idDocumentNumber }}
              </span>
              <div v-else style="display: flex; width: 2.35rem; justify-content: space-between; align-items: center;">
                <button class="edit" @click="goToAccUpdatePersonalData">
                  <img src="@/assets/images/edit_red.svg">
                </button>
                <span style="color: #e93636">尚未补充资料</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="prompt"><span>为了你的资金安全，请拍摄真实手持身份证正反面身份证的照片</span></div>
        <div class="upload">
          <div class="card">
            <img v-if="isFacade" src="@/assets/images/personalInfo/toolbar_bg1.jpg">
            <!-- <em class="hint-text">点击拍摄/上传手持人像面</em> -->
            <img v-if="isFacadePhoto" preview="0" :src="facadePhoto">
            <div style="position: absolute; width: 100%; height: 100%; right: 0; top: 0; opacity: 0;">
              <input v-if="accountInfo.idDocumentNumber && accountInfo.idDocumentNumber !== 'TEST1693844836539' && !accountInfo.idDocumentNumber.startsWith('NOID')" id="face" ref="inputMultiple1" class="inputPhoto" type="file" accept="image/*" @change="multipleChange(1)">
              <button v-else style="position: absolute; width: 100%; height: 100%; right: 0; top: 0; opacity: 0;" @click="() => showIdentityUpdatePersonalDataPopup = true" />
            </div>
            <div v-if="facadeMasking" class="masking">
              <div class="item" @click="clickPreview(1)" />
              <img src="@/assets/images/template/toolbar_close1.png" @click="closeDelePop(1)">
            </div>
          </div>
          <div class="card">
            <img v-if="isObverse" src="@/assets/images/personalInfo/toolbar_bg2.jpg">
            <!-- <em class="hint-text">点击拍摄/上传手持国徽面</em> -->
            <img v-if="isObversePhoto" preview="0" :src="obversePhoto">
            <div style="position: absolute; width: 100%; height: 100%; right: 0; top: 0; opacity: 0;">
              <input v-if="accountInfo.idDocumentNumber && accountInfo.idDocumentNumber !== 'TEST1693844836539' && !accountInfo.idDocumentNumber.startsWith('NOID')" id="obverse" ref="inputMultiple2" class="inputPhoto" type="file" accept="image/*" @change="multipleChange(2)">
              <button v-else style="position: absolute; width: 100%; height: 100%; right: 0; top: 0; opacity: 0;" @click="() => showIdentityUpdatePersonalDataPopup = true" />
            </div>
            <div v-if="obverseMasking" class="masking">
              <div class="item" @click="clickPreview(2)" />
              <img src="@/assets/images/template/toolbar_close1.png" @click="closeDelePop(2)">
            </div>
          </div>
        </div>
        <div class="btnItem dv_list">
          <ul class="small-text remind_list enable-list-type">
            <li>手持证件(照片请参考上图各示例拍摄)</li>
            <li>确保证件信息清晰完整</li>
            <li>信息仅用身份验证, 平台不做保留</li>
          </ul>
        </div>
        <div class="btnItem dv_list">
          <span class="submit" :class="isFacadePhoto&&isObversePhoto?'suc':''" @click="submit">确认并提交</span>
        </div>
      </div>
    </div>
    <!--删除照片-->
    <div v-if="isDelePop" class="popFixed">
      <div class="masking" @click="closeDelePop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>请确认要删除此照片</p>
        </div>
        <div class="btnCon">
          <span @click="closeDelePop">取消</span>
          <span @click="deleImg">删除</span>
        </div>
      </div>
    </div>
    <!--重复提交-->
    <RepeatPop v-if="isRepeatPop" />
    <!--预览图片-->
    <div v-if="isPreviewPop" class="popFixed">
      <div class="masking" @click="closePreview" />
      <img class="preview" :src="previewPic">
    </div>
    <!--检查大小-->
    <CheckSize v-if="isCheckSize" />
    <IdentityUpdatePersonalDataPopup :show="showIdentityUpdatePersonalDataPopup" @onClose="() => showIdentityUpdatePersonalDataPopup = false" />
  </div>
</template>
<script>
require('@/assets/css/identity.css')
import Header from '@/view/module/Header.vue'
import RepeatPop from '@/view/module/RepeatPop.vue'
import CheckSize from '@/view/module/CheckSize.vue'
import IdentityUpdatePersonalDataPopup from '@/view/module/IdentityUpdatePersonalDataPopup.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'Identity',
  components: { Header, RepeatPop, CheckSize, IdentityUpdatePersonalDataPopup },
  data() {
    return {
      title: '身份认证',
      isFacade: true,
      facadePhoto: '',
      facadeFile: '',
      isFacadePhoto: false,
      facadeMasking: false,
      isObverse: true,
      obversePhoto: '',
      obverseFile: '',
      isObversePhoto: false,
      obverseMasking: false,
      isDelePop: false,
      closeNum: '',
      isRepeatPop: false,
      rightContent: 'isNo',
      isPreviewPop: false,
      previewPic: '',
      isCheckSize: false,
      xhr: '',
      showIdentityUpdatePersonalDataPopup: false,
      accountInfo: {
        chineseName: '',
        idDocumentNumber: '',
        cashoutTag: ''
      }
    }
  },
  computed: {
    ...mapState(['gts2CustomerId'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', false)
    window.scrollTo(0, 0)
    this.AccTradeInfo()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    multipleChange(type) {
      let url
      const inputMultiple1 = this.$refs.inputMultiple1
      const inputMultiple2 = this.$refs.inputMultiple2
      if (type == 1) {
        if (inputMultiple1.files) {
          for (const file of inputMultiple1.files) {
            url = URL.createObjectURL(file)
            this.checkPic(file)
            this.compressImg(file, type)
            this.facadePhoto = url
            this.isFacade = false
            this.facadeMasking = true
            this.isFacadePhoto = true
          }
        }
      } else {
        if (inputMultiple2.files) {
          for (const file of inputMultiple2.files) {
            url = URL.createObjectURL(file)
            this.checkPic(file)
            this.compressImg(file, type)
            this.obversePhoto = url
            this.isObverse = false
            this.obverseMasking = true
            this.isObversePhoto = true
          }
        }
      }
      // this.$previewRefresh();
    },
    compressImg(file, type) {
      if (file.size / 1024 > 1025) { // 大于1M，进行压缩上传
        this.photoCompress(file, { quality: 0.2 }, file.name, type)
      } else {
        if (type == 1) {
          this.facadeFile = file
        } else {
          this.obverseFile = file
        }
      }
    },
    photoCompress(file, w, name, type) {
      const ready = new FileReader()
      /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file)
      const _this = this
      ready.onload = function(e) {
        const path = e.target.result
        _this.canvasDataURL(path, w, name, type)
      }
    },
    canvasDataURL(path, obj, name, type) {
      const _this = this
      const img = new Image()
      img.src = path
      img.onload = function() {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = obj.width || w
        h = obj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        if (type == 1) {
          _this.facadeFile = _this.dataURLtoFile(base64, name)
        } else {
          _this.obverseFile = _this.dataURLtoFile(base64, name)
        }
      }
    },
    // base64转换为file
    dataURLtoFile(base64, filename) { // 将base64转换为文件
      var arr = base64.split(','); var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    closeDelePop(type) {
      this.closeNum = type
      this.isDelePop = !this.isDelePop
      if (type == 1) document.getElementById('face').value = null
      else document.getElementById('obverse').value = null
    },
    deleImg() {
      this.isDelePop = !this.isDelePop
      if (this.closeNum == 1) {
        this.isFacade = true
        this.facadeMasking = false
        this.isFacadePhoto = false
      } else {
        this.isObverse = true
        this.obverseMasking = false
        this.isObversePhoto = false
      }
    },
    checkPic(file) {
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const AllUpExt = '.bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|'
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        return false
      } else if (file.size > 5242880) {
        this.isCheckSize = true
        return false
      }
      return true
    },
    clickPreview(type) {
      if (type == 1) this.previewPic = this.facadePhoto
      else this.previewPic = this.obversePhoto
      this.isPreviewPop = !this.isPreviewPop
    },
    closePreview() {
      this.isPreviewPop = !this.isPreviewPop
    },
    submit() {
      const fileFormData = new FormData()
      fileFormData.append(`idCardFrontFile`, this.facadeFile)
      fileFormData.append(`idCardBackFile`, this.obverseFile)
      if (this.facadeFile && this.obverseFile) {
        this.$bus.$emit('loading', false)
        api.uploadCertificate(fileFormData).then(res => {
          if (res.status) {
            if (res.data.code == 200) {
              this.$router.replace({ path: '/home/success' })
            } else if (res.data.code == 1038) {
              this.$bus.$emit('loading', true)
              this.toggleFixed()
              this.isRepeatPop = !this.isRepeatPop
            }
          }
        })
      }
    },
    goToAccUpdatePersonalData() {
      this.$router.push({ path: '/home/accUpdatePersonalData', query: { from: this.$route.path }})
    },
    AccTradeInfo() {
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.accountInfo = {
            chineseName: res.data.data.accountInfo.chineseName
              ? res.data.data.accountInfo.chineseName
              : '',
            idDocumentNumber: res.data.data.accountInfo.idDocumentNumber,
            cashoutTag: res.data.data.accountInfo.paySwitchCashoutSeqTagCode
          }
        }
      })
    },
  }
}
</script>
